import React, {useEffect, useState} from "react";
import firebase from "firebase";
import {Table} from "react-bootstrap";
import '../css/ManagerPage.css';
import ManagerMenu from "./components/ManagerMenu";
import ManagerModal from "./components/ManagerModal";
import bizmsg from 'bizmsg-alimtalk';
import moment from "moment";
import ManagerStatistics from "./components/ManagerStatistics";
import {IoEllipsisHorizontalSharp} from 'react-icons/io5'
import ManagerDetailModal from "./components/ManagerDetailModal";
const ManagerPage =()=>{
    const db = firebase.firestore();
    const storage = firebase.storage();
    let storageRef = storage.ref();
    const [itemList,setItemList]=useState();
    const [reservationList,setReservationList]=useState();
    const [newItem,setNewItem]=useState({name:'',price:'',url:''});
    const [id,setId]=useState('');
    const [pw,setPw]=useState('');
    const [menu,setMenu]=useState(0);
    const [modalList,setModalList]=useState(0);
    const [subFile,setSubFile]=useState();
    const [text,setText]=useState('');
    const [addOption,setAddOption]=useState([]);
    const [updateCounter,setUpdateCounter]=useState(0);
    const [onModalDetail,setOnModalDetail]=useState(false);
    const [modalDetailItem,setModalDetailItem]=useState([]);

    useEffect(()=>{
        db.collection('product').get().then((res)=>{
            let arr = []
            res.forEach((doc)=>{
                let data = doc.data();
                arr.push(data)
            })
            arr.sort((a,b)=>{
                return new Date(b.date)-new Date(a.date)
            })
            setItemList(arr)
        });
        db.collection('reservation').get().then((res)=>{
            let arr2 = []
            res.forEach((doc)=>{
                let data = doc.data();
                arr2.push(data)
            })
            arr2.sort((a,b)=>{
                return new Date(b.usertime)-new Date(a.usertime)
            })
            setReservationList(arr2);
            //arr2.filter((item)=>item.reservationState<2)
        });

    },[updateCounter]);


    const addItem =(name, price, url, url2, text, option)=>{
        const now = moment().format('YYYY.MM.DD HH:mm:ss')
        db.collection('product').add({
            name : name,
            price: price,
            url: url,
            suburl: url2,
            explan: text,
            option: option,
            date:now,
        }).then((res)=> {
            console.log("success:", res);
            alert('등록완료!');
            window.location.reload()
        }).catch(err=>console.log("error",err))
    }

    useEffect(()=>{
        console.log('itemList:',itemList)
    },[itemList])

    const [imgFile,setImgFile]=useState();

    useEffect(()=>{
        firebase.auth().onAuthStateChanged((user)=>{
            if (user) {
                setIsLogin(true)
            }
        })
    },[])

    const [isLogin,setIsLogin]=useState(false);

    useEffect(()=>{
        //로그인 확인 코드
        firebase.auth().onAuthStateChanged((user)=>{
            return !!user;
        })
    },[isLogin])

    useEffect(()=>{console.log(subFile)},[subFile])



    const onFileChange = (e) => {
        setImgFile(e.target.files[0])
    }



    const [urlBucket,setURLbucket]=useState([]);
    useEffect(()=>{
        if(urlBucket.length===2){
            addItem(newItem.name,newItem.price,urlBucket[0],urlBucket[1],text,addOption);
            setModalList(0)
        }
    },[urlBucket])

    const getImageURL =(File1,File2)=>{
        let arr =[]
        storageRef.child('image/'+ Date.now() +File1.name).put(File1).then((snapshot)=>{
            return snapshot.ref.getDownloadURL()
        }).then((URL)=>{
            // setURLbucket([...urlBucket,URL])
            arr.push(URL)
        }).then(()=>{
            storageRef.child('image/' + Date.now() + File2.name).put(File2).then((snapshot)=>{
                return snapshot.ref.getDownloadURL()
            }).then((URL2)=>{
                arr.push(URL2)
                //setURLbucket([...urlBucket,URL2])
            }).then(()=>{
                setURLbucket(arr)
            }).catch(err=>{console.log(err)})
        }).catch(err=>{console.log(err)})
    }

    const upLoad =()=>{
        getImageURL(imgFile,subFile)
    }
    const Login =()=>{
        firebase.auth().signInWithEmailAndPassword(id,pw).then((result)=>{
            console.log(result.user)
        })
    }
    const Logout =()=>{
        firebase.auth().signOut().then(()=>console.log('sign-out!'));
        window.location.reload();
    }
    const CheckReservationState=(number)=>{
        switch (number){
            case 0:
                return "입금확인"
            case 1:
                return "예약중"
            case 2:
                return "거래완료"
        }
    }

    const DeleteItem =(title)=>{
        db.collection('product').where('name','==',title).get().then((res)=>{
            let ID
            res.forEach((a)=>{
                ID= a.id
            })

            return ID
        }).then((id)=>{
            console.log("id:",id)
            db.collection('product').doc(id).delete().then(()=>{
                alert("삭제완료!");
                window.location.reload();
            }).catch((err)=>{
                console.log("err:",err)
            })
        }).catch((err)=>{
            console.log("ERR:",err)
        })
    }

    const UserCheckReservation=(name,phone,state)=>{
        console.log(name,phone)
        db.collection('reservation').where('username', '==', name).get().then((res)=>{
            let arr = []
            res.forEach((a)=>{
                arr.push(a.id)
            })
            console.log("arr:",arr)
            return arr
        }).then(arr=>{
            db.collection('reservation').where('userphone', '==', phone).get().then((res)=>
            {
                let arr2 =[]
                res.forEach((a)=>{
                    arr2.push(a.id)
                })
                console.log("arr2:",arr2)
                const result = arr.filter((item) => arr2.includes(item))
                console.log(result)
                return result
            }).then(id=>{
                console.log("id:",id)
                db.collection('reservation').doc(id[0]).update({reservationState:state}).then(res=>console.log(res))
                setUpdateCounter(updateCounter+1)
            })
        })
    }

    const sendMsg =(name,phone,pickup,item)=>{
        const boot = async ()=>{
            bizmsg.init('jejuang','3416378fc1551b7f403052829a5cad98d68143dc');
        }
        boot().then(()=>{
            bizmsg.sendMessage({
                msg: `보기 좋은 떡이 맛도 좋다! 제주앙!
${name} 고객님의 주문이 예약 완료되었습니다.

💎 예약 내역
👉 픽업날짜 : ${pickup.slice(0,-6)}
👉 픽업시간 : ${pickup.slice(-6)}
👉 주문내역 : ${item[0].name} 포함 ${item.length} 개

💎제주앙 영업시간
👉 11:00 ~ 17:00
(매주 수요일 휴무)
👉 영업시간 이내 픽업이 어려운 경우, 꼭 제주앙으로 문의 주세요!!!
연락 없을 시 노쇼 처리 예정

💎 주차 안내
👉 제주앙 가게 문 앞 주정차 가능
👉 도보 3분 거리 무료 공영 주차장 (주소 : 제주 제주시 용담일동 249-1)
👉 주차장에서 오시는 길 : https://jeju-ang.web.app/location

☎ ) 0507-1352-6572`,
                phn: phone,
                tmplId: 'post_reservation_set',
            }).catch((err)=>console.log('err:',err));
        }).then(()=>{
            UserCheckReservation(name,phone,1)
        })
    }



    return(

        <>
            {
                modalList===1&&
                <ManagerModal
                    upLoad={upLoad}
                    onFileChange={onFileChange}
                    setNewItem={setNewItem}
                    newItem={newItem}
                    setModalList={setModalList}
                    setSubFile={setSubFile}
                    text={text}
                    setText={setText}
                    addOption={addOption}
                    setAddOption={setAddOption}
                />
            }
            {
                onModalDetail&&
                <ManagerDetailModal setOnModalDetail={setOnModalDetail} modalDetailItem={modalDetailItem}/>
            }
            <ManagerMenu
                logout={Logout}
                setMenu={setMenu}
            />
            <div className={'flex__center'}>
                <h1>관리자페이지</h1>
                {
                    isLogin?
                        <div className={'login-container'}>
                            {menu===0&&
                                <>
                                    <Table className={'cart-table'}>
                                        <thead className={'cart-table__thead'}>
                                        <tr>
                                            <th>이미지</th>
                                            <th>상품명</th>
                                            <th>가격</th>
                                            <th>삭제</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            itemList&&
                                            itemList.map((item,index)=>(
                                                <tr key={index}>
                                                    <td><img src={item.url} alt={"img"} className={'img-size-50'}/></td>
                                                    <td>{item.name}</td>
                                                    <td>{item.price}</td>
                                                    <td>
                                                        <div className={'manager-delete-button flex__center'} onClick={()=>{DeleteItem(item.name)}}>Delete</div>
                                                    </td>
                                                </tr>
                                            ))
                                        }

                                        </tbody>
                                    </Table>
                                    <div className={'manager-add-button'} onClick={()=>{setModalList(1)}}>상품 추가</div>
                                </>
                            }
                            {menu===1&&
                                <Table className={'cart-table'}>
                                    <thead className={'cart-table__thead'}>
                                    <tr>
                                        <th>이름</th>
                                        <th>번호</th>
                                        <th>예약시간</th>
                                        <th>상태</th>
                                        <th>메세지</th>
                                        <th>거래완료</th>
                                        <th>상세보기</th>
                                        <th>삭제</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        reservationList&&
                                        reservationList.map((item,index)=>(
                                            <tr key={index}>
                                                <td>{item.username}</td>
                                                <td>{item.userphone}</td>
                                                <td>{item.usertime}</td>
                                                <td>{CheckReservationState(item.reservationState)}</td>
                                                <td><button onClick={()=>{
                                                    sendMsg(item.username,item.userphone,item.pickupTime,item.useritem)
                                                }}>예약확인</button></td>
                                                {
                                                    item.reservationState!==2?
                                                        <td><button onClick={()=>{UserCheckReservation(item.username,item.userphone,2)}}>완료처리</button></td>
                                                        :
                                                        <td>거래완료</td>
                                                }
                                                <td className={'manager-icon'} onClick={()=>{
                                                    setOnModalDetail(true);
                                                    setModalDetailItem(item)
                                                }}><IoEllipsisHorizontalSharp/></td>
                                                <td><button onClick={()=>{
                                                    db.collection('reservation').where('usertime','==', item.usertime).get().then((res)=>{
                                                        let ID
                                                        res.forEach((a)=>{
                                                            ID= a.id
                                                        })

                                                        return ID
                                                    }).then((id)=>{
                                                        console.log("id:",id)
                                                        db.collection('reservation').doc(id).delete().then(()=>{
                                                            alert("삭제완료!");
                                                            window.location.reload();
                                                        }).catch((err)=>{
                                                            console.log("err:",err)
                                                        })
                                                    }).catch((err)=>{
                                                        console.log("ERR:",err)
                                                    })
                                                }}>X</button></td>
                                            </tr>
                                        ))
                                    }

                                    </tbody>
                                </Table>
                            }
                            {menu===2&&
                                <ManagerStatistics
                                    reservationList={reservationList}
                                />
                            }

                        </div>
                        :
                        <div className={'login-container'}>
                            <div className={'flex-center-row'}>
                                <div className={'login-input-box'}>
                                    <input placeholder={"아이디"} onChange={(e)=>setId(e.target.value)} value={id}/>
                                    <input type={'password'} placeholder={"비밀번호"} onChange={(e)=>setPw(e.target.value)} value={pw}/>
                                </div>
                                <div className={'login-button'} onClick={()=>{Login()}}>
                                    Login
                                </div>
                            </div>
                        </div>
                }
            </div>
        </>
    );
}

export default ManagerPage
